<script>
	import { createEventDispatcher, onMount, onDestroy } from 'svelte';
	import { copiarParaAreaTransferencia } from '../utils';

	export let titulo = '';
	export let link = null;
	export let habilitarCopiarConteudo = false;
	export let target = '_blank';
	export let larguraMaxima = false;

	let elementoConteudoModal;

	const dispatch = createEventDispatcher();

	function fechar() {
		dispatch('fecharModalEvent');
	}

	const handleTeclaPressionada = e => {
		if (e.key === 'Escape') {
			fechar();
			return;
		}
	};

	onMount(() => { 
		elementoConteudoModal = document.getElementById("conteudoModal");
	});

	onDestroy(() => {
		titulo = '';
		link = '';
		// console.log('Modal destruída...');
	});
</script>

<style>
	.largura95 {
		width: 95% !important;
	}
</style>

<svelte:window on:keydown={handleTeclaPressionada} />

<div class="modal is-active">
	<div class="modal-background"></div>
	<div class="modal-card { larguraMaxima == true ? 'largura95' : '' }">
		<header class="modal-card-head">
			<p class="modal-card-title">{titulo}</p>
			<button class="delete" aria-label="close" on:click|stopPropagation={fechar}></button>
		</header>
		
		<section class="modal-card-body">
			<div class="content permitir-selecao" id="conteudoModal">
				<slot></slot>
			</div>
		</section>
		
		<footer class="modal-card-foot">
			{#if link}
			<a href="{link}" class="button is-primary" target="{target}">Acessar</a>
			{/if}
			
			<button class="button" on:click|stopPropagation={fechar}>Fechar</button>

			{#if habilitarCopiarConteudo}
			<button class="button is-primary" on:click|stopPropagation={copiarParaAreaTransferencia(elementoConteudoModal)}>Copiar conteúdo</button>
			{/if}
		</footer>
	</div>
</div>
